import { useEffect, useState } from "react";
import styles from "./insights.module.css";
import InsightsCover from "../../components/Insights/InsightsCover/insights-cover";
import PostSection from "../../components/Insights/PostSection/post-section";
import { IPostInsight } from "../../interfaces/insightPost";
import { InsightsPosts } from "../../database/insights-posts";

interface IProps {
  onHandlePages: any;
}

function formatDateType(date: string) {
  const dateObj = new Date(date);
  const day = String(dateObj.getUTCDate()).padStart(2, "0");
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
  const year = dateObj.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

const InsightsPage = ({ onHandlePages }: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [posts, setPosts] = useState<Array<IPostInsight> | []>([]);
  const [lastPost, setLastPost] = useState<IPostInsight | {}>({});

  const LoadingOverlay = () => (
    <div className={styles.loadingOverlay}>
      <div className={styles.spinner}></div>
    </div>
  );

  useEffect(() => {
    const onLoadInsights = async () => {
      try {
        setLoading(true);

        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) {
          console.error("Erro: API URL não definida.");
          return;
        }

        const response = await fetch(`${apiUrl}/insights`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const resData = await response.json();

        if (!response.ok) {
          alert(
            `${resData.message} ${resData.details}` ||
              "Erro ao buscar insights."
          );
          setLoading(false);
          return;
        }

        resData.data.forEach((el: IPostInsight) => {
          if (el.date) {
            el.date = formatDateType(el.date);
            el.username = el.user
              ? `${el.user.firstname} ${el.user.lastname}`
              : "Unknown User";
          }
        });

        return resData.data as IPostInsight[];
      } catch (error) {
        alert("Erro ao buscar insights: " + error);
        return;
      }
    };

    const mapLocalPosts = (): IPostInsight[] =>
      InsightsPosts.map((p) => ({
        _id: String(p.id),
        title: p.title,
        description: p.description,
        cover: p.cover as unknown as string,
        paragraphs: p.paragraphs,
        date: p.date,
        username: typeof p.user === "string" ? p.user : "Equipe TruEvidence",
      }));

    onLoadInsights()
      .then((data) => {
        const source = data && data.length > 0 ? data : mapLocalPosts();
        setPosts(source.slice(1));
        setLastPost(source[0]);
        setLoading(false);
      })
      .catch(() => {
        const local = mapLocalPosts();
        setPosts(local.slice(1));
        setLastPost(local[0]);
        setLoading(false);
      });
  }, [setLoading]);

  return (
    <>
      {loading ? (
        <main className={styles.empty_main}>
          <LoadingOverlay />
        </main>
      ) : (
        <main className={styles.main}>
          <InsightsCover onHandlePages={onHandlePages} postInfo={lastPost} />

          <section className={styles.posts}>
            {posts?.map((item, index) => (
              <PostSection
                key={index}
                onHandlePages={onHandlePages}
                postInfo={item}
              />
            ))}
          </section>
        </main>
      )}
    </>
  );
};

export default InsightsPage;
